import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1605"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M15.349 13.263 8.472 2.013a.553.553 0 0 0-.944 0L.651 13.263a.553.553 0 0 0 .472.841h13.754a.553.553 0 0 0 .472-.841zm-7.319-.802c-1.401 0-2.567-1.054-2.567-2.5 0-.598.261-1.335.781-1.611 0 0 .093.994.586 1.41.057-.667-.398-2.863 1.56-3.625-.069 1.225-.025 2.079.586 2.819-.055-.453.186-1.176 1.042-1.428-.072 1.292.52 1.576.52 2.435-.001 1.446-1.107 2.5-2.508 2.5z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }